<template>
    <div class="w-full flex items-start gap-x-5">
        <div class="rounded-lg min-w-[30%] bg-white p-10 text-black">
            <h2 class="text-2xl font-extralight underline">Remplir les champs suivants :</h2>
            <form @submit.prevent="saveForm" class="mt-8">
                <div class="w-full flex flex-col items-start ">
                    <label for="name" class="font-light" >Nom<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.nom" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="poste" class="font-light" >Poste<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.poste" placeholder="" name="poste" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="debut" class="font-light" >Début<span class="text-[#f44545]">*</span></label>
                    <input type="date" v-model="form.startDate" placeholder="" name="debut" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="salaire" class="font-light" >Salaire<span class="text-[#f44545]">*</span></label>
                    <input type="number" min="0" v-model="form.salaire" placeholder="" name="salaire" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="motivation" class="font-light" >Motivation<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.motivation" placeholder="" name="motivation" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <button type="submit" :disabled="asSend" class="w-full mt-8 py-3 bg-[#5357ec] text-white rounded-md">
                    <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                    <span v-if="!asSend">Enregistrer</span>
                </button>
            </form>
        </div>
        <div class="rounded-lg grow min-h-[850px] bg-white">
            <div class="mx-auto w-[89%] rounded-lg px-7 py-8 mt-10">
                <div class="w-full flex justify-center mt-14 mb-20">
                    <img src="../../../../assets/uigb-logo.png" alt="logo uigb" class="h-20 w-auto object-cover">
                </div>
                    <div class="flex justify-center">
                        <h2 class="text-4xl font-semibold text-center text-black bg-[#e5e5e5] px-16 py-6 border-2 mt-44 mb-20 border-black inline-block rounded-xl">SALARY CERTIFICATE</h2>
                    </div>
                    <p class="text-gray-700 mb-20 text-2xl">DATE</p>

                    <p class="text-gray-700 mb-14 text-2xl font-bold">
                        To Whom It May Concern:
                    </p>

                    <p class="text-gray-700 mb-14  text-2xl">
                        This is to certify that <span class="font-bold">{{ form.nom ?? "NAME TITLE" }}</span> has been employed as <span class="font-bold">{{ form.poste ?? "POSITION" }}</span> by the International University of Grand-Bassam since <span class="font-bold">{{ form.startDate ?? "DATE OF ENTRY" }}</span>.
                    </p>

                    <p class="text-gray-700 mb-14 text-2xl">
                        TITLE NAME current monthly net earnings are XOF NET <span class="font-bold">{{ form.salaire ?? "AMOUNT" }}</span>.
                    </p>

                    <p class="text-gray-700 mb-24  text-2xl">
                        This certificate is issued to him/her in support of <span class="font-bold">{{ form.motivation ?? "MOTIVE" }}</span>
                    </p>

                    <div class="text-right text-2xl">
                        <p class="text-gray-700 mr-32 font-bold">Signature</p>
                    </div>
            </div>
        </div>
    </div>
</template>
<script>
import {Loader2} from "lucide-vue-next";
import API from "@/service/API";
import toast from "@/components/ui/toast";
export default {
    name: "SalaryCertificat",
    components: {Loader2},
    data() {
        return {
            asSend: false,
            form: {
                nom: null,
                poste: null,
                startDate: null,
                salaire: null,
                motivation: null
            }
        };
    },
    methods: {
        clearForm() {
            this.form.nom = null;
            this.form.poste = null;
            this.form.startDate = null;
            this.form.salaire = null;
            this.form.motivation = null;
        },
        saveForm(){
            this.asSend = true;
            const data = {
                "content" : JSON.stringify(this.form),
                "doc_id":26,
                "user_id": localStorage.getItem("userId") ?? this.$store.getters.userId
            }
            API.post("user-docs", data)
                .then((response) => {
                    if(response.data["status"] == 'success'){
                        toast.success("Succès","Demande enregistré avec succès",4000)
                        this.clearForm();
                    }else{
                        toast.error("Oops..",response.data["message"],4000)
                    }
                })
                .catch(() => {
                    toast.error("Oops..","Il semble avoir une erreur, merci de réessayé.",4000)
                }).finally(()=>{
                    this.asSend = false;
                });
        }
    },
}
</script>